import React from "react";
import usexAPI from "store/customHooks/usexAPI";
import { getUrlPathnameAndSearch } from "utils/url";
import { setXAPIPath } from "utils/localStorage";

import FlWrapper from "components/gnb/content/util/FlWrapper";
import { xAPI_ID_VALUE } from "utils/xAPI_PATH";

function Item(props) {
    const { text, info, changeFirstDepthMenu } = props;
    const { ServiceUnit_A } = usexAPI();

    const handleClick = () => {
        ServiceUnit_A(xAPI_ID_VALUE.serviceUnit.btn_menu_0002, getUrlPathnameAndSearch(info.MENU_URL));
        changeFirstDepthMenu(info);
        setXAPIPath("G");
    };

    return <FlWrapper handleClick={handleClick}>{text}</FlWrapper>;
}

export default Item;
